/* tslint:disable */
/* eslint-disable */
export enum RouterInitState {
  Registered = 'REGISTERED',
  CertRequested = 'CERT_REQUESTED',
  RequestExpired = 'REQUEST_EXPIRED',
  Init = 'INIT',
  Normal = 'NORMAL',
  NormalRenewal = 'NORMAL_RENEWAL',
  CertDownload = 'CERT_DOWNLOAD',
  Grace = 'GRACE',
  Invalid = 'INVALID'
}
